import { TypeM3PrdGrp } from "../Maestro/M3PrdGrp.type";
import { ServiceM3Maestro } from "./M3Maestro.service";
import { PostServiceM3 } from "../../ConexionSQL/posts.service";
import { M3PrecListPrecios } from "../Maestro/m3-prec-list-precios.type";

export class ServiceListaPrecio {

    private goData: any;
    private gsIdKatios: any;
    private lPreciosSelected: string = "-1";

    //Generar JSON genÃ©rico, para validar la lista de precio
    constructor(loged_user: any, sIdProceso: string){
        var oData = { "USER": loged_user, "Proceso": sIdProceso }
        this.goData = oData;
    }

    //Obtener lista de precios
    public async GetListaPrecios(PostServiceM3: PostServiceM3, IdKatios: string) {
        try {
            this.gsIdKatios = IdKatios;
            var oServiceM3Maestro = new ServiceM3Maestro();
            var oListPrecLP: M3PrecListPrecios;
            oListPrecLP = this.GetLPreciosInStorage(IdKatios);
            if(!oListPrecLP){
                oListPrecLP = await oServiceM3Maestro.M3GET_LISTAPRECIOS_ASync(PostServiceM3, IdKatios);
                this.SaveLPreciosInStorage(oListPrecLP,IdKatios)
            }
            
            this.ValidarAPLRegla(oListPrecLP);
            //this.FindLPrecio(oListPrecLP);
            return this.lPreciosSelected;
        } catch (ex) {
            console.log(ex);
        }
    }

    /**
     * Guardar la lista de precios teniendo en cuenta la llave: RegPrecio + idkatios
     */
    public SaveLPreciosInStorage(lPrecio:any, gsIdkatios: string){
        localStorage.setItem("RegPrecio" + gsIdkatios, JSON.stringify(lPrecio));
    }

    /**
     * Guardar la lista de precios teniendo en cuenta la llave: RegPrecio + idkatios
     */
    public SaveConfigLPreciosInStorage(lPrecio:any, gsIdkatios: string){
        console.debug(lPrecio);
        sessionStorage.setItem("ConfigLP" + gsIdkatios, lPrecio);
    }

    /***
     * Obtener lista de precios desde storage teniendo en cuenta la llave: RegPrecio + idkatios
     */
    public GetLPreciosInStorage(gsIdkatios: string){
        var sPrecios = localStorage.getItem("RegPrecio" + gsIdkatios);
        var oPrecios:any;
        if(sPrecios){
            oPrecios = JSON.parse(sPrecios);
            return oPrecios;
        }
        return null;
    }

    public GetConfigLPreciosInStorage(gsIdkatios: string){
        var sPrecios = sessionStorage.getItem("ConfigLP" + gsIdkatios);
        var oPrecios:any;
        if(sPrecios){
            oPrecios = JSON.parse(sPrecios);
            return oPrecios;
        }
        return null;
    }

    //Busucar la lista de precio, ingresa el objeto de precendencia de reglas de lista de precios
    public FindLPrecio(oListPrecLP: M3PrecListPrecios) {
        
        if (oListPrecLP !== undefined && oListPrecLP != null && oListPrecLP.ID !== undefined && oListPrecLP.ID != null) {
            
            if (oListPrecLP.PRECEDENCIA !== undefined && oListPrecLP.PRECEDENCIA != null && oListPrecLP.PRECEDENCIA.length !== undefined) {
                for (const prec of oListPrecLP.PRECEDENCIA) {
                    this.ValidarAPLRegla(prec);
                    //this.FindLPrecio(prec);
                }
            }
        }
    }


    //Validar reglas, ingresa el objeto de precendencia de reglas de lista de precios
    public ValidarAPLRegla(oListPrecLP: M3PrecListPrecios): boolean{
        var bResp: boolean = false;
        if (oListPrecLP !== undefined) {
            try{
                switch (oListPrecLP.Propiedad.toUpperCase().trim()) {
                    case "EMPRESA":
                        bResp = this.Compare(oListPrecLP.Valor.toString(), this.gsIdKatios.toString())
                        break;
                    case "UBICACION":
                        bResp = this.Compare(oListPrecLP.Valor.toString(), this.goData.USER.UsuarioSistema.UBICACION.toString());
                        break;
                    case "PROCESO":
                        bResp = this.Compare(oListPrecLP.Valor.toString(), this.goData.Proceso.toString());
                        break;
                    case "HUB":
                        bResp = this.Compare(oListPrecLP.Valor.toString(), this.goData.USER.UsuarioSistema.IDHUB.toString());
                        break;
                    default:
                        bResp = this.Compare(oListPrecLP.Valor.toString(), this.goData.USER.UsuarioSistema[oListPrecLP.Propiedad.toUpperCase().trim()].toString());
                        break;
                }
            }catch{
            }
        }
        if(bResp){
            this.lPreciosSelected = oListPrecLP.ListaPrecios;
            this.FindLPrecio(oListPrecLP);
        }
        return bResp;
    }
    
    public Compare(value1, value2) {
        if (value1 == value2) {
            return true;
        }
        return false;
    }

    //Obtener configuracion/encabezado lista de precios
    public async GetConfigListaPrecios(PostServiceM3: PostServiceM3, IdKatios: string) {
        try {
            this.gsIdKatios = IdKatios;
            var oServiceM3Maestro = new ServiceM3Maestro();
            var oListPrecLP: M3PrecListPrecios;
            oListPrecLP = this.GetConfigLPreciosInStorage(IdKatios);
            if(!oListPrecLP){
                oListPrecLP = await oServiceM3Maestro.GetEncabezadoListasPrecio(PostServiceM3, IdKatios);
                this.SaveConfigLPreciosInStorage(oListPrecLP,IdKatios)
            }
            
            return oListPrecLP;
        } catch (ex) {
            console.log(ex);
        }
    }

}